import { createQueryKey } from '#providers/query/index.ts';

export const getTermsAcceptedQueryKey = (projectId?: string) =>
  createQueryKey('terms', 'isTermsAccepted', { project_id: projectId ?? '' });

export const getTermsTextQueryKey = (projectId?: string) =>
  createQueryKey('terms', 'getTermsTexts', { project_id: projectId ?? '' });
